export * from '@primeuix/themes/material/treetable';
export { default } from '@primeuix/themes/material/treetable';
